import SvgIcon from "./IconStatusSkip.svg?react";
const IconStatusSkip = SvgIcon;
export default IconStatusSkip;
